import { render } from "./Subdomains.vue?vue&type=template&id=90b50e60&scoped=true"
import script from "./Subdomains.vue?vue&type=script&lang=js"
export * from "./Subdomains.vue?vue&type=script&lang=js"

import "./Subdomains.vue?vue&type=style&index=0&id=90b50e60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b50e60"]])

export default __exports__